import PropTypes from "prop-types";

import BackgroundImage from "../../shared/image/placeholder.jpg";
import {
  buildAggregateCardMetaChips,
  buildAggregateCardPrimaryMetric,
  formatImageCardRetailerProvinceDescription,
} from "./pricingReportCardDisplay";
import {
  PRICING_REPORT_AGGREGATE_CARD_IMAGE_TRANSFORM_KEY,
  withDirectusAssetTransformKey,
} from "./pricingReportImageUrls";
import PricingReportPrintHtmlText from "./PricingReportPrintHtmlText";

function PricingReportPrintCard({ row, placeholderImageUrl }) {
  const coverUrl = withDirectusAssetTransformKey(
    row?.coverUrl,
    PRICING_REPORT_AGGREGATE_CARD_IMAGE_TRANSFORM_KEY
  );
  const imageSrc = coverUrl || placeholderImageUrl || BackgroundImage;
  const productTitle = row?.productName || "—";
  const location = formatImageCardRetailerProvinceDescription(row?.retailer, row?.province);
  const primaryMetric = buildAggregateCardPrimaryMetric(row);
  const metaChips = buildAggregateCardMetaChips(row);
  const metaLabel = metaChips.map((chip) => chip.value).filter(Boolean).join(" · ");

  return (
    <article className="pricing-report-print-cards__card">
      <div className="pricing-report-print-cards__image-wrap">
        <img
          className="pricing-report-print-cards__image"
          src={imageSrc}
          alt=""
          loading="eager"
          decoding="sync"
        />
      </div>
      <h3 className="pricing-report-print-cards__product">{productTitle}</h3>
      {location ? <p className="pricing-report-print-cards__location">{location}</p> : null}
      {primaryMetric?.value ? (
        <p className="pricing-report-print-cards__price">{primaryMetric.value}</p>
      ) : null}
      {metaLabel ? <p className="pricing-report-print-cards__meta">{metaLabel}</p> : null}
    </article>
  );
}

PricingReportPrintCard.propTypes = {
  row: PropTypes.object,
  placeholderImageUrl: PropTypes.string,
};

export default function PricingReportPrintCards({ cards }) {
  if (!cards?.rows?.length) return null;

  const { title, rows, footerNote, placeholderImageUrl } = cards;

  return (
    <section className="pricing-report-print-cards">
      {title ? (
        <PricingReportPrintHtmlText
          html={title}
          component="h2"
          className="pricing-report-print-cards__title"
        />
      ) : null}
      <div className="pricing-report-print-cards__grid">
        {rows.map((row, rowIndex) => (
          <PricingReportPrintCard
            key={row.id ?? rowIndex}
            row={row}
            placeholderImageUrl={placeholderImageUrl}
          />
        ))}
      </div>
      {footerNote ? <p className="pricing-report-print-cards__footer">{footerNote}</p> : null}
    </section>
  );
}

PricingReportPrintCards.propTypes = {
  cards: PropTypes.shape({
    title: PropTypes.string,
    rows: PropTypes.array,
    footerNote: PropTypes.string,
    placeholderImageUrl: PropTypes.string,
  }),
};
